import { Component, input, output } from "@angular/core";

@Component({
  selector: "toggle",
  imports: [],
  templateUrl: "./toggle.html",
  styles: [
    `
      :host {
        display: inline-flex;
      }

      .toggle-btn {
        display: inline-flex;
        gap: 0.5rem;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }

      .toggle-btn:focus-visible {
        outline: 0.125rem solid #2563eb;
        outline-offset: 0.1875rem;
        border-radius: 9999px;
      }

      .toggle-icon {
        width: 2.75rem;
        height: 1.5rem;
      }

      .toggle-icon .track {
        fill: #d1d5db;
        transition: fill 200ms ease;
      }

      .toggle-icon .thumb {
        fill: #ffffff;
        filter: drop-shadow(0 0.0625rem 0.125rem rgba(0, 0, 0, 0.2));
        transition: transform 220ms ease;
        transform: translateX(0);
      }

      .toggle-icon .check {
        stroke: #ffffff;
        stroke-width: 2;
        fill: none;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-dasharray: 14;
        stroke-dashoffset: 14;
        opacity: 0;
        transition:
          stroke-dashoffset 200ms ease,
          opacity 200ms ease;
      }

      .toggle-btn.is-active .track {
        fill: var(--color-vinciBlue-600);
      }

      .toggle-btn.is-active .thumb {
        transform: translateX(1.25rem);
      }

      .toggle-btn.is-active .check {
        stroke-dashoffset: 0;
        opacity: 1;
      }
    `,
  ],
})
export class Toggle {
  isActive = input.required<boolean>();
  text? = input<string>();
  toggleChange = output<boolean>();

  onToggle(): void {
    this.toggleChange.emit(!this.isActive());
  }
}
